import classNames from 'classnames'

import style from './Status.module.scss'

const Status = ({ className, label, type }) => {
  return <div className={classNames(style.status, style[type], className)}>{label}</div>
}

export default Status
